import { ICourseResult, ApprovalStatus } from './course';
import { ICourseInviteResult } from './course-invite';
import { ICourseModuleResult } from './course-module';

export interface ICourseModuleStudentResult {
  readonly id: string;
  readonly courseModuleId: number;
  readonly courseModule: Partial<ICourseModuleResult>;
  readonly userId: string;
  readonly courseStudentId: string;
  readonly registeredAt: Date;
  readonly startedAt?: Date;
  readonly expiredAt?: Date;
}

export const APPROVAL_STATUS = {
  0: 'pending',
  1: 'approved',
  2: 'rejected',
};

export interface ICourseStudentResult {
  readonly id: string;
  readonly userId: string;
  readonly orderId?: string;
  readonly courseId: string;
  readonly approvalStatus: ApprovalStatus;
  readonly isActive: boolean;
  readonly registeredAt: Date;
  readonly startedAt?: Date;
  readonly expiredAt?: Date;
  readonly hasProceedingAccess: boolean;
  readonly courseModuleStudents: Partial<ICourseModuleStudentResult>[];
}

export interface IStudentCourseResult extends ICourseResult {
  readonly approvalStatus: ApprovalStatus;
  readonly missingItems: number;
  readonly hasStarted: boolean;
}

export interface IStudentProgressResult {
  readonly id: string;
  readonly studentId: string;
  readonly moduleItemId: string;
  readonly isComplete: boolean;
  readonly isLocked: boolean;
}

export interface IStudentRowData extends Partial<ICourseStudentResult>,
  Partial<ICourseInviteResult> { }
